import { Button, Typography } from '@mui/material';
import {
  StyledFlexItem,
  StyledIconTextContainer,
  StyledSpaceBetweenBox,
} from './Home.styled';
import { OpenInNew } from '@mui/icons-material';
import React from 'react';

type HomeSectionProps = {
  title: React.ReactNode;
  linkTo: string;
  content: React.ReactNode;
  buttonTitle: string;
};
const HomeSection: React.FC<HomeSectionProps> = ({
  title,
  linkTo,
  content,
  buttonTitle,
}) => {
  return (
    <StyledFlexItem elevation={5}>
      <StyledIconTextContainer>
        <StyledSpaceBetweenBox>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            {title}
          </Typography>
          <Button
            variant="text"
            color="primary"
            href={linkTo}
            size="small"
            endIcon={<OpenInNew />}
          >
            {buttonTitle}
          </Button>
        </StyledSpaceBetweenBox>
      </StyledIconTextContainer>
      {content}
    </StyledFlexItem>
  );
};
export default HomeSection;
